export const TIERS = {
    ESSENTIALS: {label: 'Essentials', description: 'Clean relevant data without sentiment'},
    SENTIMENT:  {label: 'Sentiment', description: 'Clean relevant data with accurate sentiment'},
    TOPICS:     {label: 'Topics', description: 'Clean relevant data with accurate sentiment and topics'}
};